import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
    withStyles, Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography
} from "@material-ui/core";
import CancelAcceptForm from "../../../../../Common/CancelAcceptForm";
import t from "../../../../../../languages/pl";
import { buttonStyle } from "../../buttonGroupStyle";
import { compose } from 'recompose';
import CarPricingTable from './CarPricingTable'

const useStyles = theme => ({
    button: buttonStyle(theme),
});

const CarPricing = props => {
    const { classes, name, onDialogOpen, carPricing, onSubmit } = props;
    const [open, setOpen] = useState(false);

    const handleDialogOpen = () => {
        setOpen(true);
        onDialogOpen && onDialogOpen();
    };

    const handleRadioClick = (selectedPricing) => {
        onSubmit(selectedPricing);
    };

    return (
        <React.Fragment>
            <Button
                variant="outlined"
                className={classes.button}
                onClick={handleDialogOpen}
            >
                {t.pricing}
            </Button>

            <Dialog
                open={open}
                fullWidth={true}
                maxWidth="xl"
                onClose={() => setOpen(false)}
            >
                <DialogTitle>
                    {t.carPricing} {name}
                </DialogTitle>
                <DialogContent>
                    <CarPricingTable
                        selectedPricingId={carPricing}
                        onRadioClick={handleRadioClick}
                    />
                </DialogContent>
                <DialogActions>
                    <CancelAcceptForm
                        onCancel={() => setOpen(false)}
                        cancelName={t.close}
                        showSubmitButton={false}
                    />
                </DialogActions>
            </Dialog>

        </React.Fragment>
    );
};

CarPricing.propTypes = {
    classes: PropTypes.object,
    name: PropTypes.string,
    onDialogOpen: PropTypes.func,
    onSubmit: PropTypes.func,
};

const mapStateToProps = ({ carsReducer }) => ({
    carPricing: carsReducer.carPricing
});

export default compose(
    withStyles(useStyles),
    connect(mapStateToProps)
)(CarPricing);